import { ApiService } from "@/services/api/ApiService";
import { ApiKey, ApiKeyWithSecret } from "@/types/api-keys";

export class ApiKeyService {
  static async listApiKeys(): Promise<ApiKey[]> {
    const response = await ApiService.invoke<{ api_keys: ApiKey[]; count: number }>({
      resource: "api-keys",
      action: "list",
    });
    return response?.api_keys || [];
  }

  static async createApiKey(name: string): Promise<ApiKeyWithSecret> {
    const response = await ApiService.invoke<{ api_key: ApiKeyWithSecret }>({
      resource: "api-keys",
      action: "create",
      data: { name },
    });
    if (!response?.api_key) {
      throw new Error("Failed to create API key");
    }
    return response.api_key;
  }

  static async revokeApiKey(keyId: string): Promise<void> {
    await ApiService.invoke<{ success: boolean }>({
      resource: "api-keys",
      action: "revoke",
      id: keyId,
    });
  }

  static async deleteApiKey(keyId: string): Promise<void> {
    await ApiService.invoke<{ success: boolean }>({
      resource: "api-keys",
      action: "delete",
      id: keyId,
    });
  }
}
